import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "intl-pluralrules";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// import EDMSubmit from './components/EDM/EDMSubmit';
import EDMSubmitV2 from "./components/EDM/EDMSubmitV2";
import EDMConfirm from "./components/EDM/EDMConfirmV2";
import EDMTWSubmit from "./components/EDM/EDMTWSubmit";
import EDMTWConfirm from "./components/EDM/EDMTWConfirm";

import { Provider } from "react-redux";
import store from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

const theme = createTheme({
  typography: {
    fontFamily:
      "Montserrat, Noto Sans TC, Noto Sans SC, Arial, Helvetica, sans-serif",
  },
});

const Root = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE_URL}>
        <Switch>
          {/* EDM */}
          <Route exact path="/edm/confirm-tw" component={EDMTWConfirm} />
          <Route exact path="/edm/form-tw" component={EDMTWSubmit} />
          <Route exact path="/edm/confirm" component={EDMConfirm} />
          <Route exact path="/edm" component={EDMSubmitV2} />
          {/* <Route exact path="/edm/:channel" component={EDMSubmitV2} /> */}
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
};

if (process.env.NODE_ENV !== "production") {
  Sentry.init({
    dsn: "http://c59701adce7d2cc2b52be75a8339ce5f@10.64.200.183:9000/2",
    integrations: [
      Sentry.replayIntegration(),
    ],
    environment: "uat",
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    debug: true,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}


ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
